const COLOR_THEMES = {
  "qc": {
    primary: "#4A90E2",
    primary_hover: "#3483de", // darken(primary, 5%),
    primary_transparent8: "rgba(74,144,226,0.8)",
    primary_transparent: "rgba(74,144,226,0.5)", // fade_out(primary, 0.5),
    active: "#9FC522",
    active_hover: "#8daf1e", //darken(#9FC522, 5%),
    active_disabled: "rgba(141,175,30,0.5)", //#dfecb5",
    active_transparent: "rgba(159,197,34,0.5)", // fade_out(#9FC522, 0.5),
    assetsPath: "../images",
  },
  "caes": {
    primary: "#58595b",
    primary_hover: "#4b4c4e", //darken(#58595b, 5%),
    primary_transparent8: "rgba(74,144,226,0.8)",
    primary_transparent: "rgba(88,89,91,0.5)", // fade_out(primary, 0.5),
    active: "#f46c42",
    active_hover: "#f3592a", //darken(#f46c42, 5%),
    active_disabled: "rgba(243,89,42, 0.5)",
    active_transparent: "rgba(244,108,66,0.5)", //fade_out(#9FC522, 0.5),
    assetsPath: "../images-caes",
  }
};

export const COLOR = {
  black: '#000000',
  blackLight: '#4a4a4a',
  white: '#ffffff',
  blue: '#ffffff',
  red: '#f11515',
  red_transparent: "rgba(241, 21, 21 , 0.5)",
}

export default COLOR_THEMES
